import React from "react";
import "./Pink_btn.css";
import { Button } from "react-bootstrap";

function Pink_btn({ btnText }) {
  return (
    <>
      <section className="Pink_btn_holder">
        <Button className="Pink_btn">{btnText}</Button>
      </section>
    </>
  );
}

export default Pink_btn;
